module.exports = __webpack_public_path__ + "static/assets/5f365b739d526739fe2135344e657405.svg";